<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="nav-container">
        <div class="logo">
          <img src="/images/logo.png" alt="MIITTU" class="logo-img">
          <span>Miittu</span>
        </div>
        <ul class="nav-menu">
          <li><a href="#home" @click="scrollTo('home')">首页</a></li>
          <li><a href="#about" @click="scrollTo('about')">关于我们</a></li>
          <li><a href="#services" @click="scrollTo('services')">企业服务</a></li>
          <li><a href="#philosophy" @click="scrollTo('philosophy')">企业理念</a></li>
          <li><a href="#products" @click="scrollTo('products')">产品中心</a></li>
          <li><a href="#contact" @click="scrollTo('contact')">联系我们</a></li>
        </ul>
      </div>
    </nav>

    <!-- Hero Section -->
    <section id="home" class="hero" :style="{ backgroundImage: 'url(/images/hero-1-bg-img.png)' }">
      <div class="hero-content">
        <div class="hero-image">
          <img src="/images/hero-img.png" alt="Glasses">
        </div>
        <h1 class="hero-title">Miittu</h1>
        <h2 class="hero-subtitle">享受清晰视界</h2>
        <p class="hero-description">清晰世界，从这里开始</p>
        <button class="hero-button" @click="scrollTo('about')">开始 →</button>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="section about">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <p class="section-description">以客户为中心，覆盖镜片、镜框、视力查找、视力主医生的检查、眼镜定制等服务</p>
        <div class="about-grid">
          <div class="about-card">
            <img src="/images/about_1.webp" alt="有一种服务" class="about-image">
            <h3>有一种服务</h3>
            <p>是心与心的交流，所以我们聚力倾听,迎合需求汇聚点滴，逐梦未来，立尚载梦起航，用全新的创新激情点燃新的梦想！</p>
          </div>
          <div class="about-card">
            <img src="/images/about_2.webp" alt="精致的测量仪" class="about-image">
            <h3>精致的测量仪</h3>
            <p>好的设计需要好的设计工具来实现出来进口MEAS精准测量工具</p>
          </div>
          <div class="about-card">
            <img src="/images/about_3.webp" alt="专业设计团队" class="about-image">
            <h3>专业设计团队</h3>
            <p>专业的THYT的设计团队在线智能设计,高质量的眼镜从多次检查和修改中实现</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业服务 -->
    <section id="services" class="section services">
      <div class="container">
        <h2 class="section-title">企业服务</h2>
        <p class="section-description">为您提供全面的定制服务与全球配送解决方案</p>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon" :style="{ backgroundImage: 'url(/images/service-icon-bg.png)' }">
              <img src="/images/services-icon/icon-1.png" alt="来图定制">
            </div>
            <h3>来图定制</h3>
            <p>我们提供专业的来图定制服务，确保每一副眼镜框都能符合您的设计要求和品牌特色</p>
          </div>
          <div class="service-card">
            <div class="service-icon" :style="{ backgroundImage: 'url(/images/service-icon-bg.png)' }">
              <img src="/images/services-icon/icon-2.png" alt="提供样品">
            </div>
            <h3>提供样品</h3>
            <p>为了帮助您更好地了解我们的产品质量和工艺，我们提供样品服务</p>
          </div>
          <div class="service-card">
            <div class="service-icon" :style="{ backgroundImage: 'url(/images/service-icon-bg.png)' }">
              <img src="/images/services-icon/icon-3.png" alt="全球发货">
            </div>
            <h3>全球发货</h3>
            <p>我们拥有完善的物流体系，能够实现全球范围内的快速发货</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业理念 -->
    <section id="philosophy" class="section philosophy">
      <div class="container">
        <h2 class="section-title">企业理念</h2>
        <p class="section-subtitle">COMPANY OVERVIEW</p>
        <div class="philosophy-grid">
          <div class="philosophy-item">
            <img src="/images/features/img-1.png" alt="实验室" class="philosophy-image">
            <h3>实验室 LAB</h3>
            <p>公司建立了具有国际标准的检测实验室，公司生产的眼镜架和太阳镜产品质量已达到国际先进标准。</p>
          </div>
          <div class="philosophy-item">
            <img src="/images/features/img-2.png" alt="展示厅" class="philosophy-image">
            <h3>展示厅 SHOW ROOM</h3>
            <p>公司建立了大型展厅，陈列展示公司生产各个系列的产品，服务客户选到心仪的产品.</p>
          </div>
          <div class="philosophy-item">
            <img src="/images/features/img-3.png" alt="注塑车间" class="philosophy-image">
            <h3>注塑车间 INJECTION WORKSHOP</h3>
            <p>生产注塑架的现代化大型注塑车间</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品中心 -->
    <section id="products" class="section products">
      <div class="container">
        <h2 class="section-title">产品中心</h2>
        <p class="section-subtitle">PRODUCT CENTER</p>
        <div class="products-grid">
          <div class="product-item">
            <img src="/images/project/1.png" alt="STYLE A">
            <h3>STYLE A</h3>
          </div>
          <div class="product-item">
            <img src="/images/project/2.png" alt="STYLE B">
            <h3>STYLE B</h3>
          </div>
          <div class="product-item">
            <img src="/images/project/3.png" alt="STYLE C">
            <h3>STYLE C</h3>
          </div>
          <div class="product-item">
            <img src="/images/project/4.png" alt="STYLE D">
            <h3>STYLE D</h3>
          </div>
          <div class="product-item">
            <img src="/images/project/5.png" alt="STYLE E">
            <h3>STYLE E</h3>
          </div>
          <div class="product-item">
            <img src="/images/project/6.png" alt="STYLE F">
            <h3>STYLE F</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻动态 -->
    <section class="section news">
      <div class="container">
        <h2 class="section-title">新闻动态</h2>
        <p class="section-subtitle">NEWS</p>
        <div class="news-list">
          <div class="news-item">
            <img src="/images/blog/1.jpg" alt="新闻1" class="news-image">
            <div class="news-content">
              <h4>余江这家眼镜公司用智能制造助推高质量发展</h4>
              <p>一排排自动插片机上有九条智能航吊线，三条镜片强化加硬流水线正在紧锣密鼓地安装，在余江眼镜产业园区</p>
              <span class="news-date">07 Jan 2024</span>
            </div>
          </div>
          <div class="news-item">
            <img src="/images/blog/img-2.jpg" alt="新闻2" class="news-image">
            <div class="news-content">
              <h4>2024江西战略性新兴产业企业50强</h4>
              <p>高新区8家上榜！"2024江西战略性新兴产业企业50强"榜单发布！</p>
              <span class="news-date">17 Jan 2024</span>
            </div>
          </div>
          <div class="news-item">
            <img src="/images/blog/2.jpg" alt="新闻3" class="news-image">
            <div class="news-content">
              <h4>我国"小眼镜"人数超1亿 专家：眼负荷过重是诱因</h4>
              <p>我国"小眼镜"人数超1亿 专家：眼负荷过重是诱因报告显示，我国四年级、八年级的学生视力不良检出率分别为36.5%和65.3%</p>
              <span class="news-date">22 Jan 2024</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="section contact">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <h3>联系我们</h3>
            <p>Email: 3579969571#qq.com(把#改成@)</p>
          </div>
          <form class="contact-form" @submit.prevent="handleSubmit">
            <input type="text" placeholder="姓名" v-model="form.name" required>
            <input type="email" placeholder="邮箱" v-model="form.email" required>
            <textarea placeholder="信息" v-model="form.message" required></textarea>
            <button type="submit">发送</button>
          </form>
        </div>
        <p class="contact-description">我们凭借坚实的技术基础、强大的人才储备、深刻的市场洞悉以客户为中心，以服务客户为宗旨，成为时尚的眼镜行业</p>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>{{ currentYear }} ©江西科强光学有限公司. All Rights Reserved</p>
        <p><a style="color: white;text-decoration: none;" href="https://beian.miit.gov.cn/">备案号：赣ICP备2020010899号-6</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      currentYear: '2026'
    }
  },
  mounted() {
    const date = new Date();
    this.currentYear = date.getFullYear();
  },
  methods: {
    scrollTo(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    },
    handleSubmit() {
      alert('表单已提交！');
      this.form = {name: '', email: '', message: ''};
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
  color: #333;
}

#app {
  min-height: 100vh;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 1rem 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-img {
  height: 40px;
  width: auto;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.nav-menu a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-menu a:hover {
  color: #007bff;
}

/* Hero Section */
.hero {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f8f9fa;
  color: #333;
  text-align: center;
  margin-top: 70px;
  position: relative;
  overflow: hidden;
}

.hero-content {
  max-width: 800px;
  padding: 2rem;
  position: relative;
  z-index: 1;
}

.hero-image {
  margin-bottom: 2rem;
}

.hero-image img {
  max-width: 300px;
  height: auto;
}

.hero-title {
  font-size: 5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  color: #333;
}

.hero-subtitle {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 300;
  color: #333;
}

.hero-description {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #666;
}

.hero-button {
  padding: 1rem 3rem;
  font-size: 1.1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: bold;
  transition: transform 0.3s, box-shadow 0.3s, background 0.3s;
}

.hero-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  background: #0056b3;
}

/* 通用Section样式 */
.section {
  padding: 5rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-title {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.section-subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 3rem;
  font-size: 1rem;
  letter-spacing: 2px;
}

.section-description {
  text-align: center;
  color: #666;
  margin-bottom: 3rem;
  font-size: 1.1rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 关于我们 */
.about {
  background: #f8f9fa;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.about-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  text-align: center;
}

.about-card:hover {
  transform: translateY(-5px);
}

.about-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.about-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.about-card p {
  color: #666;
  line-height: 1.8;
}

/* 企业服务 */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.service-card {
  background: #f1b33f;
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s;
  position: relative;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-icon img {
  max-width: 50px;
  max-height: 50px;
}

.service-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.service-card p {
  color: #666;
  line-height: 1.8;
}

/* 企业理念 */
.philosophy {
  background: #f8f9fa;
}

.philosophy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.philosophy-item {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.philosophy-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.philosophy-item h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.philosophy-item p {
  color: #666;
  line-height: 1.8;
}

/* 产品中心 */
.products {
  background: white;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.product-item {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  transition: transform 0.3s, background 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-item:hover {
  transform: translateY(-5px);
  background: #e9ecef;
}

.product-item img {
  width: 100%;
  height: 200px;
  object-fit: contain;
  margin-bottom: 1rem;
}

.product-item h3 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin: 0;
}

/* 新闻动态 */
.news {
  background: #f8f9fa;
}

.news-list {
  max-width: 900px;
  margin: 3rem auto 0;
}

.news-item {
  background: white;
  padding: 0;
  margin-bottom: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  overflow: hidden;
  display: flex;
}

.news-item:hover {
  transform: translateX(5px);
}

.news-image {
  width: 300px;
  height: 200px;
  object-fit: cover;
  flex-shrink: 0;
}

.news-content {
  padding: 2rem;
  flex: 1;
}

.news-item h4 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.news-item p {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.8;
}

.news-date {
  color: #999;
  font-size: 0.9rem;
}

/* 联系我们 */
.contact {
  background: white;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.contact-info h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.contact-info p {
  color: #666;
  font-size: 1.1rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-form input,
.contact-form textarea {
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  font-family: inherit;
}

.contact-form textarea {
  min-height: 120px;
  resize: vertical;
}

.contact-form button {
  padding: 1rem 2rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s;
}

.contact-form button:hover {
  background: #5568d3;
}

.contact-description {
  text-align: center;
  color: #666;
  margin-top: 2rem;
  font-size: 1rem;
  line-height: 1.8;
}

/* 页脚 */
.footer {
  background: #2c3e50;
  color: white;
  padding: 2rem 0;
  text-align: center;
}

.footer p {
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-menu {
    flex-direction: column;
    gap: 1rem;
  }

  .hero-title {
    font-size: 3rem;
  }

  .hero-subtitle {
    font-size: 1.8rem;
  }

  .contact-content {
    grid-template-columns: 1fr;
  }

  .about-grid,
  .services-grid,
  .philosophy-grid {
    grid-template-columns: 1fr;
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .news-item {
    flex-direction: column;
  }

  .news-image {
    width: 100%;
    height: 200px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.5rem;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }

  .news-item {
    flex-direction: column;
  }
}
</style>
